import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import ProfileCard from "./components/profileCard";
import CustomTab, {
  TabContainer,
} from "../../../../components/tabs/customTabs";
import BasicCard from "./components/basicCard";
import EducationCard from "./components/educationCard";
import ExperienceCard from "./components/experienceCard";
import DocumentCard from "./components/documentsCard";
import LeaveCard from "./components/leaveCard";
import AttendanceCard from "./components/attendanceCard";
import SalaryCard from "./components/salaryCard";
import PermissionsCard from "./components/permissionsCard";
import useCommonFetch from "../../../../../hooks/useCommonFetch";
import { getUserDetailProfile } from "../../../../../services/workspace/user.service";
import BankCard from "./components/bankCard";

const items = [
  { label: "Staff Directory", path: "/hr/staff-directory" },
  { label: "Staff Profile", path: "" },
];

const Profile = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const {
    loading,
    data: staffData,
    fetchData,
  } = useCommonFetch(getUserDetailProfile, {
    id: id,
    dataPath: "user",
    errorMessage: "Failed to fetch user detail!",
    customParams: {
      additional_info: true,
      with:"documents"
      // with: "workspace,createdBy,designation,department,educations,experiences,attendances,documents,leaves",
    },
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromUrl = Number(params.get("tab"));
    if (!isNaN(tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, [location.search]);

  // ✅ when user clicks tab
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`?tab=${tabId}`);
  };

  const heandleFetchData = () => {
    fetchData(
      {
        additional_info: true,
        // with: "workspace,createdBy,designation,department,educations,experiences,attendances,documents,leaves",
      },
      true,
      id
    );
  };

  const tabs = [
    {
      id: "tab1",
      label: "Overview",
      content: <BasicCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData={heandleFetchData} />,
    },
    {
      id: "tab2",
      label: "Education",
      content: <EducationCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData ={heandleFetchData}/>,
    },
    {
      id: "tab3",
      label: "Experience",
      content: <ExperienceCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData ={heandleFetchData} />,
    },
    {
      id: "tab4",
      label: "Attendance",
      content: <AttendanceCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData={heandleFetchData}/>,
    },
    // {
    //   id: "tab5",
    //   label: "Leaves",
    //   content: <LeaveCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData={heandleFetchData} />,
    // },
    {
      id: "tab5",
      label: "Documents",
      content: <DocumentCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData={heandleFetchData} />,
    },
    {
      id: "tab6",
      label: "Salary",
      content: <SalaryCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData={heandleFetchData} />,
    },
    
     {
      id: "tab7",
      label: "Bank Details",
      content: <BankCard fetchData={fetchData} staff={staffData} loading={loading} heandleFetchData={heandleFetchData} />,
    },
    {
      id: "tab8",
      label: "Permissions",
      content: <PermissionsCard staff={staffData} loading={loading} heandleFetchData={heandleFetchData} />,
    }, 
  ];

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader breadcrumbs={items} />
      <ProfileCard staffData={staffData} />
      <div className="flex flex-col gap-2 ">
        <CustomTab
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
        <div className="max-h-[calc(100vh-39vh)] h-[calc(100vh-39vh)] overflow-y-auto scrollbar-hidden ">
          <TabContainer tabs={tabs} activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
};

export default Profile;
